import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

const observeTypes = types.model('observeTypes', {
  name: types.maybeNull(types.string),
  label: types.maybeNull(types.string)
});

const GetObserveTypes = types
  .model('GetObserveTypes', {
    data: types.optional(types.array(observeTypes), [])
  })
  .actions((self) => ({
    fetch(payload) {
      Framework.getEventManager().publish(constants.FETCH_OBSERVE_TYPES, {
        payload
      });
    },
    setResponse(response) {
      applySnapshot(self, response.data);
      Framework.getEventManager().publish(constants.SET_OBSERVE_TYPES);
    },
    resetStoreValues() {
      const initialState = [];
      applySnapshot(self.data, initialState);
      Framework.getEventManager().publish(constants.SET_OBSERVE_TYPES);
    }
  }));

export default GetObserveTypes;
